
var { isMobile } = require("./lib/breakpoints");
var { makeTranslate, classify, COLORS } = require("./lib/helpers");

var d3 = {
  ...require("d3-selection/dist/d3-selection.min"),
  ...require("d3-scale/dist/d3-scale.min"),
  ...require("d3-axis/dist/d3-axis.min")
};

// Render a bar chart.
module.exports = function(config) {
  // Setup
  var labelColumn = "item";
  var valueColumn = "amt";

  var blockHeight = 20;
  if (isMobile.matches) {
    blockHeight = 15;
  }
  var blockGap = 1.5;

  var margins = {
    top: 20,
    right: 20,
    bottom: 20,
    left: 20
  };

  var ticksY = 4;

  // Determine largest bin
  var largestBin = Math.max.apply(
    null,
    config.data.map(b => b.length)
  );

  // Calculate actual chart dimensions
  var chartWidth = config.width - margins.left - margins.right;
  var chartHeight = (blockHeight + blockGap) * largestBin;

  // Clear existing graphic (for redraw)
  var containerElement = d3.select(config.container);
  containerElement.html("");

  // Create the root SVG element.
  var chartWrapper = containerElement
    .append("div")
    .attr("class", "graphic-wrapper");

  var chartElement = chartWrapper
    .append("svg")
    .attr("width", chartWidth + margins.left + margins.right )
    .attr("height", chartHeight + margins.top + margins.bottom +25)
    .append("g")
    .attr("transform", makeTranslate(margins.left, margins.top));

  // Create D3 scale objects.
  var xScale = d3
    .scaleBand()
    .domain(config.bins.slice(0, -1))
    .range([0, chartWidth])
    .padding(0.1);

  var yScale = d3
    .scaleLinear()
    .domain([0, largestBin])
    .range([chartHeight, 0]);

  // Create D3 axes.
  var xAxis = d3
    .axisBottom()
    .scale(xScale)
    .tickFormat((d) => {
      var label = ""
      if (isMobile.matches){
        if (d % 50 == 0 && d != 0){
          label =  d + "%"
        } else {
          label = ""
        }
        return label
      } else if (d % 20 == 0 && d != 0){
          label =  d + "%"
        } else {
          label = ""
        }
        return label
    });

  var yAxis = d3
    .axisLeft()
    .scale(yScale)
    .ticks(ticksY)
    .tickFormat(d => d);

  // Render axes to chart.
  var xAxisElement = chartElement
    .append("g")
    .attr("class", "x axis")
    .attr("transform", makeTranslate(0, chartHeight))
    .call(xAxis);

  d3.select(".x.axis .domain").remove();

  // Create xAxis label
  xAxisElement
    .append("text")
    .attr("class", "label-xaxis")
    .attr("transform", makeTranslate(chartWidth / 2, margins.bottom + 20 ))
    .style("font-size", 12)
    .html(LABELS.title_x);

  // Render grid to chart.
  var yAxisGrid = function() {
    return yAxis;
  };

  var yAxisElement = chartElement
    .append("g")
    .attr("class", "y grid")
    .call(
      yAxisGrid()
        .tickSize(-chartWidth, 0)
        // .tickFormat("")
    );

    yAxisElement.select(".tick:last-of-type text")
    .clone()
    .attr("x", "2.5em")
    // .attr("class", "shadow")
    // .text(LABELS.title_y)
    .clone()
    .attr("class", "label")
    .text(LABELS.title_y);

  var bandwidth = xScale.bandwidth();
  var shift = -(bandwidth / 2) - (bandwidth * 0.1) / 2;
  var tickShift = function(d, i) {
    var existing = this.getAttribute("transform").match(
      /translate\(([^)]+)\)/
    )[1];
    existing = existing.split(",").map(Number);
    existing[0] += shift;
    existing[1] += 3;
    return makeTranslate(...existing);
  };

  // Shift tick marks
  chartElement.selectAll(".x.axis .tick").attr("transform", tickShift);

  var lastTick = chartElement
    .select(".x.axis")
    .append("g")
    .attr("class", "tick")
    .attr("transform", function() {
      var lastBin = xScale.domain()[xScale.domain().length - 1];
      var x = xScale(lastBin) + bandwidth + (bandwidth * 0.1) / 2;
      var y = 3;
      return makeTranslate(x, y);
    });

  lastTick
    .append("line")
    .attr("x1", 0)
    .attr("x2", 0)
    .attr("y1", 0)
    .attr("y2", 6);

  lastTick
    .append("text")
    .attr("text-anchor", "middle")
    .attr("x", 0)
    .attr("y", 9)
    .attr("dy", "0.71em")
    .attr("fill", "currentColor")
    .text(function() {
      var t = config.bins[config.bins.length - 1];
      if (t > 0) {
        return + t + "%";
      } else {
        return t + "%";
      }
    });

    var zeroTick = chartElement
    .select(".x.axis")
    .append("g")
    .attr("class", "tick")
    .attr("transform", function() {
      var zeroBin = xScale.domain()[xScale.domain().length - 12];
      var x = xScale(zeroBin) + bandwidth + (bandwidth * 0.1) / 2;
      var y = 3;
      return makeTranslate(x, y);
    });

    zeroTick
    .append("text")
    .attr("text-anchor", "middle")
    .attr("x", 0)
    .attr("y", 9)
    .attr("dy", "0.71em")
    .attr("dx", xScale(0)+ (xScale.bandwidth() * -7.2))
    .attr("fill", "currentColor")
    .text("0%");

  // Render bins to chart.
  var bins = chartElement
    .selectAll(".bin")
    .data(config.data)
    .enter()
    .append("g")
    .attr("class", (d, i) => "bin bin-" + i)
    .attr("transform", (d, i) => makeTranslate(xScale(config.bins[i]), 0));

  bins
    .selectAll("rect")
    .data(function(d, i) {
      // add the bin index to each row of data so we can assign the right color
      var formattedData = [];
      Object.keys(d).forEach(function(k) {
        var v = d[k];
        formattedData.push({ key: k, value: v, parentIndex: i });
      });
      return formattedData;
    })
    .enter()
    .append("rect")
    .attr("width", xScale.bandwidth())
    .attr("x", 0)
    .attr("y", (d, i) => chartHeight - (blockHeight + blockGap) * (i + 1))
    .attr("height", blockHeight)
    .attr("fill", d => config.colors[d.parentIndex])
    .attr("class", d => classify(d.value));

  // Render bin values.
  bins
    .append("g")
    .attr("class", "value")
    .selectAll("text")
    .data(function(d) {
      return Object.keys(d).map(key => ({ key, value: d[key] }));
    })
    .enter()
    .append("text")
    .attr("text-anchor", "middle")
    .attr("x", xScale.bandwidth() / 2)
    .attr("y", (d, i) => chartHeight - (blockHeight + blockGap) * (i + 1))
    .attr("dy", blockHeight / 2 + 4)
    .text(d => d.value);

  // Render annotations
  var annotations = chartElement.append("g").attr("class", "annotations");

  annotations
    .append("text")
    .attr("class", "label-top")
    .attr("x", xScale(0)+ (xScale.bandwidth() * -.2))
    .attr("text-anchor", "end")
    .attr("y", -10)
    .html(LABELS.annotation_left);

  annotations
    .append("text")
    .attr("class", "label-top")
    .attr("x", xScale(1))
    .attr("text-anchor", "begin")
    .attr("y", -10)
    .html(LABELS.annotation_right);


    //tv
    annotations
    .append("text")
    .attr("class", "label-item")
    .attr("x", xScale(0) + (xScale.bandwidth() * (isMobile.matches ? -5.2: -4.4)))
    .attr("text-anchor", "begin")
    .attr("y", isMobile.matches? 100: 135)
    .html(isMobile.matches ? LABELS.annotation_1_m:LABELS.annotation_1);


    //screwdriver
    annotations
    .append("text")
    .attr("class", "label-item")
    .attr("x", xScale(0) + (xScale.bandwidth() * (isMobile.matches ? -8 : -7.6)))
    .attr("text-anchor", "begin")
    .attr("y", 122)
    .html(isMobile.matches ? LABELS.annotation_2_m :LABELS.annotation_2);


    //no change
    annotations
    .append("text")
    .attr("class", "label-item")
    .attr("x", xScale(0) + (xScale.bandwidth() * (isMobile.matches ? -2.45: -0.5)))
    .attr("text-anchor", "begin")
    .attr("y", isMobile.matches ?30:40)
    .html(LABELS.annotation_3_m);



    //oats
    annotations
    .append("text")
    .attr("class", "label-item")
    .attr("x", xScale(0) + (xScale.bandwidth() * (isMobile.matches ? 7 : 8.7)))
    .attr("text-anchor", "begin")
    .attr("y", isMobile.matches? 62: 83)
    .html(LABELS.annotation_4_m);


    //tp
    annotations
    .append("text")
    .attr("class", "label-item")
    .attr("x", xScale(0) + (xScale.bandwidth() * (isMobile.matches ? 5 : 6)))
    .attr("text-anchor", "begin")
    .attr("y", isMobile.matches? 20: 40)
    .html(isMobile.matches ? LABELS.annotation_5_m :LABELS.annotation_5);

    //aluminum foil
    annotations
    .append("text")
    .attr("class", "label-item")
    .attr("x", xScale(0) + (xScale.bandwidth() * 5))
    .attr("text-anchor", "begin")
    .attr("y", isMobile.matches? 11: 13)
    .html(isMobile.matches ? LABELS.annotation_6_m :LABELS.annotation_6);

    annotations
    .append('defs')
    .append('marker')
    .attr('id', 'dot')
    .attr('viewBox', [0, 0, 20, 20])
    .attr('refX', 10)
    .attr('refY', 10)
    .attr('markerWidth', 4)
    .attr('markerHeight', 4)
    .append('circle')
    .attr('cx', 10)
    .attr('cy', 10)
    .attr('r', 10)
    .style('fill', '#888');


    //screwdriver
    annotations
    .append("line")
    .attr("class", "pointer")
    .style("stroke", "#888")
    .style("stroke-width", isMobile.matches ? 1: 1.25)
    .attr("x1", xScale(0) + (xScale.bandwidth() * -7.25))
    .attr("y1", isMobile.matches ? -1000: 168)
    .attr("x2", xScale(0) + (xScale.bandwidth() * -7.25))
    .attr("y2", isMobile.matches ? -1000: 152)
    .attr("marker-start", "url(#dot)");


    //no change
    annotations
    .append("line")
    .attr("class", "pointer")
    .style("stroke", "#888")
    .style("stroke-width", 1.25)
    .attr("x1", (xScale(0) + xScale(1))/2.01)
    .attr("y1", isMobile.matches ? 95: 125)
    .attr("x2", isMobile.matches ? (xScale(0)+(xScale.bandwidth() * -1)):(xScale(0) + xScale(1))/2.01)
    .attr("y2", isMobile.matches ? 78: 90)
    .attr("marker-start", "url(#dot)");

    //tv
    annotations
    .append("line")
    .attr("class", "pointer")
    .style("stroke", "#888")
    .style("stroke-width", 1.25)
    .attr("x1", xScale(0) + (xScale.bandwidth() * -2.4))
    .attr("y1", isMobile.matches ? 125: 160)
    .attr("x2", xScale(0) + (xScale.bandwidth() * -3.25))
    .attr("y2", isMobile.matches ? 115: 140)
    .attr("marker-start", "url(#dot)");

    //oats
    annotations
    .append("line")
    .attr("class", "pointer")
    .style("stroke", "#888")
    .style("stroke-width", 1.25)
    .attr("x1", xScale(0) + (xScale.bandwidth() * 9.4))
    .attr("y1", isMobile.matches ? 127: 163)
    .attr("x2", xScale(0) + (xScale.bandwidth() * 9.4))
    .attr("y2", isMobile.matches ? 75: 100)
    .attr("marker-start", "url(#dot)");


    //tp
    annotations
    .append("line")
    .attr("class", "pointer")
    .style("stroke", "#888")
    .style("stroke-width", 1.25)
    .attr("x1", xScale(0) + (xScale.bandwidth() * 6))
    .attr("y1", isMobile.matches ? 44: 59)
    .attr("x2", xScale(0) + (xScale.bandwidth() * 6.4))
    .attr("y2", isMobile.matches ? 24: 45)
    .attr("marker-start", "url(#dot)");

//aluminum foil
    annotations
    .append("line")
    .attr("class", "pointer")
    .style("stroke", "#888")
    .style("stroke-width", 1.25)
    .attr("x1", xScale(0) + (xScale.bandwidth() * 4.5))
    .attr("y1", isMobile.matches ? -1000: 10)
    .attr("x2", xScale(0) + (xScale.bandwidth() * 4.95))
    .attr("y2", isMobile.matches ? -1000: 10)
    .attr("marker-start", "url(#dot)");

      annotations
    .append("line")
    .attr("class", "axis-no-change")
    .attr("x1", (xScale(0) + xScale(1))/2.01)
    .attr("y1", -margins.top)
    .attr("x2",(xScale(0) + xScale(1))/2.01)
    .attr("y2", chartHeight)
    .attr("stroke-width", xScale.bandwidth())
    .attr("stroke-alignment", "right");

};